<template>
    <div class="elle-locations-list">
        <div class="elle-locations-list--grid">
            <CardsLocationHorizontal v-for="location in locations" :key="location.id" :location="location" />
        </div>
    </div>
</template>

<script setup lang="ts">
import type { CmsItem } from '~/types/cms';

const props = withDefaults(
    defineProps<{
        locations?: CmsItem[];
    }>(),
    {
        locations: () => []
    }
);

const locations = computed(() => props.locations);
</script>
